module.exports = __webpack_public_path__ + "static/media/cases_3d_01d.0aa36348.jpg";